import React from "react";

import { CouponDto } from "services/coupons/restModels";

import { formatDate } from "shared/lib/dateTime";
import {
    DataTable,
    DataTableColumn,
    DeleteIcon,
    EditIcon,
    IconButton,
    Pagination,
} from "shared/ui";

import { useCouponsContext } from "features/Coupons/context";
import { discountLabel, usagesLabel } from "features/Coupons/lib/couponLabels";

import { Code, Expired, RowActions } from "./styles";

export const CouponsTable = () => {
    const state = useCouponsContext();

    const validityLabel = (coupon: CouponDto) => {
        const label = `${formatDate(coupon.startDate)} – ${formatDate(coupon.endDate)}`;

        // Истёкший промокод гасим цветом: в списке он лежит вперемешку с действующими,
        // и по одним датам это читается не сразу.
        return coupon.endDate < Date.now() ? <Expired>{label}</Expired> : label;
    };

    const columns: DataTableColumn<CouponDto>[] = [
        {
            key: "code",
            title: "Промокод",
            role: "primary",
            render: (coupon) => <Code>{coupon.code}</Code>,
        },
        {
            key: "discount",
            title: "Скидка",
            role: "secondary",
            width: 130,
            align: "right",
            render: (coupon) => discountLabel(coupon, state.formatterFor),
        },
        {
            key: "usages",
            title: "Использовано",
            role: "secondary",
            width: 130,
            align: "right",
            render: (coupon) => usagesLabel(coupon),
        },
        {
            key: "validity",
            title: "Срок действия",
            role: "secondary",
            width: 200,
            render: (coupon) => validityLabel(coupon),
        },
        {
            key: "actions",
            role: "action",
            width: 96,
            render: (coupon) => (
                <RowActions>
                    <IconButton
                        label="Редактировать промокод"
                        onClick={() => state.openEditDialog(coupon)}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton
                        label="Удалить промокод"
                        onClick={() => state.openDeleteDialog(coupon)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </RowActions>
            ),
        },
    ];

    return (
        <DataTable
            columns={columns}
            rows={state.coupons}
            rowKey={(coupon) => coupon.id}
            footer={
                <Pagination
                    page={state.page}
                    pageSize={state.pageSize}
                    total={state.total}
                    onChange={state.setPage}
                />
            }
        />
    );
};
